export default __webpack_public_path__ + "static/media/통해.25315994.svg";